import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Chartkick from 'vue-chartkick';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.use(VueAxios, axios);
Vue.use(Chartkick);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
